import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalAlertService } from 'src/app/services/global-alert.service';
import { GlobalService } from 'src/app/services/global.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-adm-aom',
  templateUrl: './adm-aom.component.html',
  styleUrls: ['./adm-aom.component.scss']
})
export class AdmAomComponent implements OnInit {

  clientClass;
  proyectos = [];
  constructor(public global: GlobalService, public ruta: Router, public alerta: GlobalAlertService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.clientClass = this.global.CLIENTDATALIWA[8];
    $(function () {
      this.table = $('#aomTableHT').DataTable({
        'responsive': false,
        'destroy': true,
        'retrieve': true,
        'paging': true,
        'pagingType': 'numbers',
        'language': {
          'url': '//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json'
        }
      })
    });
  }

}
